import EventEmitter from "./EventEmitter";

export default class Sizes extends EventEmitter {
  constructor() {
    super();

    //Resize event
    window.addEventListener("resize", () => {
      this.trigger("resize");
    });
  }
}
